import * as React from "react";
import { forwardRef } from "react";
const SvgIconUpload = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={18} height={18} viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g transform="translate(1 1)" stroke="#348CFD" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round"><circle cx={8} cy={8} r={8} /><path d="M8 3.273v9.454M4 7.273l4-4 4 4" /></g></svg>;
const ForwardRef = forwardRef(SvgIconUpload);
export { ForwardRef as ReactComponent };